import { em } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import React, { useEffect, useMemo, useRef } from "react";

interface AnchorProps {
  id: string;
  className?: string;
  children?: React.ReactNode;
}

export const Anchor: React.FC<AnchorProps> = ({
  id,
  className = "",
  children,
}) => {
  const anchorRef = useRef<HTMLDivElement>(null);
  const isMobile = useMediaQuery(`(max-width: ${em(992)})`);

  const offset = useMemo(() => (isMobile ? 102 : 147), [isMobile]);

  useEffect(() => {
    const handleHashChange = () => {
      if (window.location.hash === `#${id}` && anchorRef.current) {
        const elementPosition = anchorRef.current.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    };

    handleHashChange();
    window.addEventListener("hashchange", handleHashChange);

    const handleDirectLink = () => {
      if (window.location.hash === `#${id}`) {
        setTimeout(handleHashChange, 100);
      }
    };
    handleDirectLink();

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [id, offset]);

  return (
    <div
      ref={anchorRef}
      id={id}
      className={className}
      style={{ scrollMarginTop: `${offset}px` }}
    >
      {children}
    </div>
  );
};
